import type { ProductLogoSmallProps } from "../types";

/**
 * 小サイズのPermissionAndRolesロゴアイコン
 */
export function ProductLogoSmallPermissionAndRoles({
  size = 20,
  color = "#646467",
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5898 3C17.4654 1.87501 16.5117 1 15.3535 1C14.1954 1 13.2416 1.87501 13.1172 3H13.1035V4H12.1035C11.8274 4 11.6035 4.22386 11.6035 4.5V8.5C11.6035 8.77614 11.8274 9 12.1035 9H18.6035C18.8797 9 19.1035 8.77614 19.1035 8.5V4.5C19.1035 4.22386 18.8797 4 18.6035 4H17.6035V3H17.5898ZM14.6035 3.20688V4H16.1035V3.20688L16.0989 3.16481C16.0576 2.79141 15.7386 2.5 15.3535 2.5C14.9685 2.5 14.6494 2.79141 14.6082 3.16481L14.6035 3.20688ZM15.3535 7.25C15.7677 7.25 16.1035 6.91421 16.1035 6.5C16.1035 6.08579 15.7677 5.75 15.3535 5.75C14.9393 5.75 14.6035 6.08579 14.6035 6.5C14.6035 6.91421 14.9393 7.25 15.3535 7.25Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3535 11.5C13.2824 11.5 11.6035 13.1789 11.6035 15.25C11.6035 17.3211 13.2824 19 15.3535 19C17.4246 19 19.1035 17.3211 19.1035 15.25C19.1035 13.1789 17.4246 11.5 15.3535 11.5ZM17.0059 13.7774C16.8757 13.6472 16.6647 13.6472 16.5345 13.7774L14.7904 15.5214L14.213 14.944C14.0828 14.8139 13.8718 14.8139 13.7416 14.944L13.5059 15.1797C13.3757 15.3099 13.3757 15.521 13.5059 15.6511L14.5547 16.7C14.6849 16.8301 14.8959 16.8301 15.0261 16.7L17.2416 14.4845C17.3718 14.3543 17.3718 14.1432 17.2416 14.0131L17.0059 13.7774Z"
        fill={color}
      />
      <path
        d="M5.10352 6.5C5.10352 7.60457 4.20809 8.5 3.10352 8.5C1.99895 8.5 1.10352 7.60457 1.10352 6.5C1.10352 5.39543 1.99895 4.5 3.10352 4.5C4.20809 4.5 5.10352 5.39543 5.10352 6.5Z"
        fill={color}
      />
      <path
        d="M10.6035 5.75C10.8797 5.75 11.1035 5.97386 11.1035 6.25V6.75C11.1035 7.02614 10.8797 7.25 10.6035 7.25H6.10352C5.82737 7.25 5.60352 7.02614 5.60352 6.75V6.25C5.60352 5.97386 5.82737 5.75 6.10352 5.75L10.6035 5.75Z"
        fill={color}
      />
      <path
        d="M10.6035 14.5C10.8797 14.5 11.1035 14.7239 11.1035 15V15.5C11.1035 15.7761 10.8797 16 10.6035 16H8.10352C7.82737 16 7.60352 15.7761 7.60352 15.5V15C7.60352 14.7239 7.82737 14.5 8.10352 14.5H10.6035Z"
        fill={color}
      />
      <path
        d="M9.10352 15.5C9.10352 15.7761 8.87966 16 8.60352 16H8.10352C7.82737 16 7.60352 15.7761 7.60352 15.5L7.60352 6.25C7.60352 5.97386 7.82737 5.75 8.10352 5.75H8.60352C8.87966 5.75 9.10352 5.97386 9.10352 6.25L9.10352 15.5Z"
        fill={color}
      />
    </svg>
  );
}
